import { Grid, styled, Card } from "@mui/material";

interface StatusProps {
    isActive: boolean;
}

export const Styled = {
    List: styled(Grid)`
        background-color: ${props => props.theme.palette.secondary.dark};
        border: 1px solid ${props => props.theme.palette.secondary.main};
        border-radius: 16px;
        padding: 32px;
        transition: border-color 0.5s ease, color 0.5s ease;

        &:hover {
            border-color: ${props => props.theme.palette.secondary.light};
        }

        ${props => props.theme.breakpoints.down("md")} {
            border-radius: unset;
        }
    `,
    Card: styled(Card)<StatusProps>`
        background-color: ${props =>
            props.isActive
                ? props.theme.palette.primary.main
                : props.theme.palette.action.disabledBackground};
        padding: 20px;
        border: 2px solid
            ${props =>
                props.isActive
                    ? props.theme.palette.primary.dark
                    : props.theme.palette.action.disabled};
        border-radius: 16px;
        box-shadow: ${props => (props.isActive ? props.theme.shadows[4] : props.theme.shadows[1])};
        width: 250px;
        height: 150px;
        text-align: center;
        color: ${props =>
            props.isActive
                ? props.theme.palette.primary.contrastText
                : props.theme.palette.text.disabled};
        transition: background-color 0.5s, color 0.5s, box-shadow 0.3s, border-color 0.3s;

        & .MuiTypography-root {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            text-align: center;
        }

        &:hover {
            background-color: ${props =>
                props.isActive
                    ? props.theme.palette.primary.dark
                    : props.theme.palette.action.disabledBackground};
            box-shadow: ${props => props.theme.shadows[6]};
            border-color: ${props =>
                props.isActive
                    ? props.theme.palette.primary.main
                    : props.theme.palette.action.disabled};
            cursor: pointer;
        }
    `,
};
